require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./work-tesco-stores-ni.json") })
        }
      }, "path---work-tesco-stores-ni");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---work-tesco-stores-ni!./.cache/json/work-tesco-stores-ni.json
// module id = 1535
// module chunks = 231608221292675